module.exports = __webpack_public_path__ + "img/130.4.6903a182.png";